import type { ReactNode } from 'react';

// ── Branded empty state (2026-08-15) ─────────────────────────────────────────
// Replaces bare "No X" text lines across the ASC app. Inline SVG reticle in
// the estate palette (navy #060e1c · gold #c9a96e · cyan #00d4ff) — license-
// clean vector, no stock imagery, per Wayne's ruling. Keep copy factual:
// what's empty and (optionally) the action that fills it.

function ReticleMark({ size = 72 }: { size?: number }) {
    return (
        <svg width={size} height={size} viewBox="0 0 72 72" role="img" aria-hidden="true">
            <circle cx="36" cy="36" r="30" fill="none" stroke="#c9a96e" strokeWidth="1" opacity="0.7" />
            <circle cx="36" cy="36" r="21" fill="none" stroke="#22384f" strokeWidth="0.75" />
            <circle cx="36" cy="36" r="12" fill="none" stroke="#22384f" strokeWidth="0.75" />
            <g stroke="#00d4ff" strokeWidth="1" opacity="0.55">
                <line x1="36" y1="2" x2="36" y2="12" />
                <line x1="36" y1="60" x2="36" y2="70" />
                <line x1="2" y1="36" x2="12" y2="36" />
                <line x1="60" y1="36" x2="70" y2="36" />
            </g>
            <g fill="#00d4ff" opacity="0.7">
                <circle cx="57" cy="36" r="1.8" />
                <circle cx="36" cy="57" r="1.8" />
                <circle cx="15" cy="36" r="1.8" />
                <circle cx="36" cy="15" r="1.8" />
            </g>
            <circle cx="36" cy="36" r="4" fill="#c9a96e" opacity="0.85" />
        </svg>
    );
}

export function EmptyState({ title, hint, action }: {
    title: string;
    hint?: string;
    action?: ReactNode;
}) {
    return (
        <div className="flex flex-col items-center justify-center text-center py-10 px-6 rounded-lg border border-dashed border-pt-border bg-pt-panel/40">
            <ReticleMark />
            <div className="mt-4 text-sm font-medium text-pt-text">{title}</div>
            {hint && <div className="mt-1 text-xs text-pt-text-muted max-w-sm">{hint}</div>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
